export default __webpack_public_path__ + "static/media/1799.de265fa2.png";